import React, { useState, useEffect } from 'react';
import RenderizarProduto from '../Utils/RenderizarProduto';

import { useProvider, Toast } from '../../context/MenuProvider';
import { Link, useParams, useNavigate} from 'react-router-dom';


const ProdutosContent = ({venda, setVenda }) => {
    const {
      crud,
      buscarDadosPorId,
      salvarDados,
    } = useProvider();
    const { loading } = crud || {};
    const navigate = useNavigate();
    const [itemForm, setItemForm] = useState({});
    
    const getItem = (e) => {
      return venda.itens?.find(x => x.produto.id === e.id);
    };
    
    
    useEffect(()=>{
      if(venda?.itens){
        atualizarValorUnitario();
      }
    },[itemForm])
    
    
    const atualizarValorUnitario = () => {
      setVenda((prevVenda) => {
        const listaAtualizada = prevVenda.itens.map((item) =>
          item.produto.id === itemForm?.produto?.id ? { ...item, valor: itemForm?.valor } : item
        );
    
        return {
          ...prevVenda,
          itens: listaAtualizada,
        };
      });
    };

    const updateProduto = async (e, q) => {
      
      const item = getItem(e);
      
      let listaAtualizada;
    
      if (item) {
        listaAtualizada = venda.itens?.map((produto) =>
          produto.produto === item.produto
            ? { ...produto, quantidade: produto.quantidade + q }
            : produto
        );
      } 
      listaAtualizada = listaAtualizada?.filter(x => x.quantidade > 0) || [];
      
      const tPago = venda.pagamentos?.filter(x=>x.pago).reduce((acc, x) => acc + parseFloat(x.valor||0), 0) || 0;
      const tTotal = listaAtualizada.reduce((acc, x) => acc + (parseFloat(x.valor) * x.quantidade), 0); 
      if (tPago>tTotal) return;
      
      // setVenda((prevVenda) => ({
      //     ...prevVenda, 
      //     itens: listaAtualizada,
      // }));
      
      try{
        const response = await buscarDadosPorId('local_registros', 'checkout');
        let pagamentos = [];
        if (listaAtualizada.length > 0){
          pagamentos = response?.venda?.pagamentos || []
        }
        const item = { 
            ...response,
            venda: {
              ...response?.venda,
              itens: listaAtualizada,
              pagamentos: pagamentos,
            },
        }
        await salvarDados('local_registros', {
          ...item,
          id:"checkout"
        });
        setVenda(item?.venda)
      }catch(err){
        
      }finally{
      }

      if(listaAtualizada?.length<=0){
        navigate(`/checkout/adicionar-produtos`, { replace: true });
      }
  };
  
    useEffect(()=>{
        const carregarCheckout = async () => {
          try {
            const response = await buscarDadosPorId('local_registros', 'checkout');
            if (response) {
              if (!response?.venda?.cliente){
                navigate("/checkout/selecionar-cliente",{ replace:true });
              }
            } else {
              //alert(`Response: ${JSON.stringify(response)}`)
              console.warn('Response não é um array ou está vazio');
            }
          } catch (error) {
            //alert(`Catx: ${error}`)
            //alert(error)
            console.error('Erro ao carregar checkout:', error);
          }
        };
        carregarCheckout();
    },[venda])

    return (
          <>
            <h6 className="border-dashed-bottom">Produtos</h6>
              <div className="">
                  <div id="listaCkItensProdutos" className="list-group mt-3">
                      {venda.itens?.length > 0 ? (
                          venda.itens?.map((x) => (
                            <RenderizarProduto
                              key={x.produto.id}
                              onClick2 = {()=> updateProduto(x.produto, -1)}
                              onClick3 = {()=> updateProduto(x.produto, 1)}
                              //to={`/produtos/${x.id}`}
                              src={x.produto.foto_do_produto}
                              col2={getItem(x.produto) ?"col-auto":""}
                              titulo3={`${getItem(x.produto)?getItem(x.produto).quantidade+'x':''}`}
                              //text3="Selecionado"
                              //bcolor={getCor(x.produto)}
                              lm='mb-1'
                              //icon:'bi-box-seam text-muted'
                              titulo={x.produto.nome_do_produto}
                              //text2={parseFloat(x.valor).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}
                              label="R$"
                              formItem={x}
                              setFormItem={setItemForm}
                              //itemEditForm={setItemForm}
                              //text4={`${x.produto.controlar_estoque?`${x.produto.quantidade_em_estoque} unidades em estoque`:''}`}
                            />
                          ))
                      ) : (
                          !loading && <p className="text-center text-muted">Nenhum produto encontrado.</p>
                      )}
                  </div>
              </div>
          </>
        )
};

export default ProdutosContent;